module.exports = __webpack_public_path__ + "static/media/DSC_0232.2c147084.jpg";